import gsap from 'gsap'
import { lenis } from './lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

gsap.config({
  nullTargetWarn: false
})

export let initAnimations, Intro, ParallaxFooter, Path

initAnimations = () => {
	document.fonts.ready.then(() => {
		Intro()
		ParallaxFooter()
		Path()
	})
}

Path = () => {
	const paths = document.querySelectorAll('.path')

	let start

	paths.forEach(path => {
		const progress = path.querySelector('.path__progress')

		if (window.innerWidth > 1024) {
			start = 'top 40%'
		} else {
			start = 'top 25%'
		}

		gsap.timeline({
			scrollTrigger: {
				trigger: path,
				start: start,
				end: 'bottom 30%',
				toggleActions: 'play resume reverse resume',
				// markers: true
			}
		})

		.fromTo(progress, {
			top: 0
		}, {
			top: '100%',
			yPercent: -100,
			duration: 1.2,
			ease: 'expo.inOut'
		}, 0)
	})
}

Intro = () => {
	// const header = document.querySelector('.header__inner')
	const content = document.querySelector('.banner')
	const heading = document.querySelectorAll('.banner__tagline, .banner__heading')
	const image = document.querySelector('.banner__image')
	const path = document.querySelector('.banner__path')
	// const text = document.querySelector('.banner__text')
	// const buttons = document.querySelector('.banner__buttons')
	// const image = document.querySelector('.banner__image-holder')

	if (!heading || window.isLivePreview) return 

	let split = SplitText.create(heading, { type: 'words', aria: 'none' })

	const tl = gsap.timeline({
		delay: window.initialLoad ? 0.5 : 0,
	})

	tl.fromTo(split.words, {
		opacity: 0,
		// skewX: -20,
		willChange: 'filter, transform',
		filter: 'blur(8px)'
	}, {
		ease: 'sine',
		opacity: 1,
		// skewX: 0,
		duration: 1,
		filter: 'blur(0px)',
		stagger: 0.04
	}, 0)

	tl.fromTo(image, {
		opacity: 0,
		filter: 'blur(12px)'
	}, {
		opacity: 1,
		filter: 'blur(0px)',
		duration: 1.8,
	}, 0)

	tl.fromTo(path, {
		opacity: 0,
	}, {
		opacity: 1,
		duration: 1.2,
	}, 0)

	// tl.fromTo(split.lines, {
	// 	yPercent: 105
	// }, {
	// 	yPercent: 0,
	// 	duration: 1.6,
	// 	stagger: 0.1,
	// 	ease: 'expo',
	// })

	// tl.fromTo([text, buttons, image], {
	// 	opacity: 0,
	// 	y: 75
	// }, {
	// 	opacity: 1,
	// 	y: 0,
	// 	duration: 1.6,
	// 	stagger: 0.1,
	// 	ease: 'expo.out',
	// }, '-=1.4')
}

ParallaxFooter = () => {
  const footer = document.querySelector('.footer')
  const inner = footer.querySelector('.container')

  if (window.innerWidth <= 1024) return

  gsap.fromTo(inner, {
		yPercent: -32,
		scale: 1
	}, {
		scrollTrigger: {
			trigger: footer,
			start: 'top bottom',
			end: 'bottom bottom',
			scrub: true
		},
		yPercent: 0,
		scale: 1
	})
}

export default () => { }